import { GetCommonSettings } from '@themes/common/data';
export const FormatMoney = (cents, format, showSign = false, showSymbol = true, symbolOnly = false) => {
    var _a, _b;
    if (!format) {
        const settings = GetCommonSettings();
        format = settings.money_format;
    }
    // If symbolOnly is true, extract and return only the currency symbol
    if (symbolOnly) {
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        // Check if symbol is before placeholder (like ${{amount}})
        const beforeMatch = format.match(/(.+?)\{\{/);
        const beforeSymbol = beforeMatch && beforeMatch[1] ? beforeMatch[1].trim() : '';
        // Check if symbol is after placeholder (like {{amount}} Kr)
        const afterMatch = format.match(/\}\}(.+)/);
        const afterSymbol = afterMatch && afterMatch[1] ? afterMatch[1].trim() : '';
        // Return combined symbols or empty string if none found
        return beforeSymbol + afterSymbol || '';
    }
    if (typeof cents == 'string') {
        cents = Number(cents.replace('.', ''));
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';
    const isNegative = cents < 0;
    const absValue = Math.abs(Number(cents));
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision !== null && precision !== void 0 ? precision : 2;
        if (isNaN(number) || number == null) {
            return 0;
        }
        const numberWithDecimals = (number / 100.0).toFixed(precision);
        // Fallback to original implementation
        thousands = thousands !== null && thousands !== void 0 ? thousands : ',';
        decimal = decimal !== null && decimal !== void 0 ? decimal : '.';
        const parts = numberWithDecimals.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    }
    switch ((_b = (_a = formatString.match(placeholderRegex)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : 'amount') {
        case 'amount':
            value = formatWithDelimiters(absValue, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(absValue, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(absValue, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(absValue, 0, '.', ',');
            break;
    }
    // Apply sign if showSign is true
    if (showSign) {
        if (isNegative) {
            value = '-' + value;
        }
        else {
            value = '+' + value;
        }
    }
    else if (isNegative) {
        // Always show negative sign even if showSign is false
        value = '-' + value;
    }
    // Handle currency symbol display
    if (showSymbol) {
        return formatString.replace(placeholderRegex, value.toString());
    }
    else {
        // Extract the placeholder pattern and replace the entire format with just the value
        const match = formatString.match(placeholderRegex);
        if (match && match.index !== undefined) {
            // Just return the formatted value without the surrounding currency format
            return value.toString();
        }
        // Fallback if no placeholder found
        return formatString.replace(placeholderRegex, value.toString());
    }
};
export const DisplayPrice = (price, showSign = false, showSymbol = true, symbolOnly = false) => {
    return FormatMoney(price * 100, undefined, showSign, showSymbol, symbolOnly);
};
globalThis.Shopify = globalThis.Shopify || {};
globalThis.Shopify.formatMoney = globalThis.Shopify.formatMoney || FormatMoney;
globalThis.SB = globalThis.SB || {};
globalThis.SB.formatMoney = globalThis.SB.formatMoney || FormatMoney;
